import { Heart, PawPrint } from "lucide-react";
import { useLang } from "@/i18n";

const Badge = ({ icon: Icon, label, testId, tone }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-2.5 text-[11px] md:text-xs uppercase tracking-[0.22em] ${tone}`}
  >
    <span className="relative inline-flex items-center justify-center w-7 h-7 rounded-full border border-current/40">
      <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
    </span>
    {label}
  </span>
);

export const FriendlyBadges = ({ tone = "text-anthracite/70", className = "" }) => {
  const { t } = useLang();
  return (
    <div className={`flex flex-wrap items-center gap-x-8 gap-y-3 ${className}`} data-testid="friendly-badges">
      <Badge icon={Heart} label={t.badges.lgbtq} testId="badge-lgbtq" tone={tone} />
      <Badge icon={PawPrint} label={t.badges.animal} testId="badge-animal" tone={tone} />
    </div>
  );
};

export const MarqueeBadge = ({ icon: Icon, label, testId }) => (
  <span className="inline-flex items-center gap-3 text-olive" data-testid={testId}>
    <span className="inline-flex items-center justify-center w-9 h-9 md:w-11 md:h-11 rounded-full border border-olive/40">
      <Icon className="w-4 h-4 md:w-5 md:h-5" strokeWidth={1.5} />
    </span>
    <span className="text-xs md:text-sm uppercase tracking-[0.25em]">{label}</span>
  </span>
);

export { Heart, PawPrint };
